import React from 'react';
import { Link } from 'react-router-dom';
import { Field, reduxForm } from 'redux-form';
import { Alert, Form, Button } from 'react-bootstrap';
import { Input, Checkbox, FormActions, PhoneNumber } from '../../common/components/formControls';
import validators from '../../common/services/validators';
import FontAwesome from 'react-fontawesome';
import { withNamespaces } from 'react-i18next';
import { init } from 'react-facebook-pixel';
import TimeZonePicker from '../../common/components/TimeZonePicker';

const SettingsForm = ({ error, handleSubmit, pristine, submitting, submitSucceeded, initialValues, cities,
	enableClassReminder, countryCode, timeZones, enableUserTimeZone, requireAddress, requirePostcode, t }) => {
	let messageToParent = initialValues && initialValues.messageToParent;
	return (
		<Form horizontal onSubmit={handleSubmit}>
			{error && <Alert bsStyle='danger'>{error}</Alert>}
			{submitSucceeded && <Alert bsStyle='success'>{t('Common_UpdateSuccess')}</Alert>}
			{messageToParent && <Alert bsStyle='info'>{messageToParent}</Alert>}
			<Field name='firstName' component={Input} horizontal required type='text' label={t('FO_Parent_FirstName')} validate={validators.required} />
			<Field name='lastName' component={Input} horizontal required type='text' label={t('FO_Parent_LastName')} validate={validators.required} />
			<Field name='email' component={Input} horizontal required type='text' label={t('FO_Parent_Email')} validate={[validators.required, validators.email]} />
			<Field name='city' component={Input} componentClass='select' horizontal label={t('FO_Parent_CentreLocation')}>
				<option />
				{cities.map(city => <option key={city} value={city}>{city}</option>)}
			</Field>
			<Field name='address' component={Input} horizontal required={requireAddress} type='text' label={t('FO_Parent_Address')} validate={requireAddress && validators.required} />
			<Field name='postcode' component={Input} horizontal required={requirePostcode} type='text' label={t('FO_Parent_Postcode')} validate={requirePostcode && validators.required} />
			<Field name='phoneNumber' component={PhoneNumber} defaultCountry={countryCode} horizontal required type='text' label={t('FO_Parent_PhoneNumber')} validate={validators.required} />
			<Field name='childRelationship' component={Input} horizontal type='text' label={t('FO_Parent_ChildRelationship')} />
			{enableUserTimeZone && <TimeZonePicker name='timeZone' horizontal label={t('FO_Parent_TimeZone')} timeZones={timeZones} />}
			<Field name='marketingEmailConsent' component={Checkbox} horizontal checkboxClass='icheckbox_minimal-grey bg' label='&nbsp;' staticLabel={t('FO_Parent_MarketingEmailConsent')} type='checkbox' />
			{enableClassReminder && <Field name='noClassReminderConsent' component={Checkbox} horizontal checkboxClass='icheckbox_minimal-grey bg' label='&nbsp;' staticLabel={t('FO_Parent_ClassReminderConsent')} type='checkbox' />}
			<FormActions horizontal>
				<Button type='submit' disabled={pristine || submitting} bsStyle='primary' className='pull-right btn-block-xxs'>{t('Common_Save')} <FontAwesome name='arrow-circle-right' /></Button>
			</FormActions>
		</Form>
	);
};

export default reduxForm({ form: 'parent', enableReinitialize: true })(withNamespaces()(SettingsForm));
